export const aboutHero = {
  title: "About Pawwash",
  subtitle: "Convenient self-serve dog washing for Glasgow dog owners",
};

export const aboutSections = [
  {
    title: "Why we exist",
    body: "We know how messy dog washing can be at home — muddy paws on the carpet, wet dog smell in the car. Pawwash gives you a quick, professional clean for your dog without the hassle. Save your home and your car, and get back to enjoying time with your pet.",
  },
  {
    title: "Where we are",
    body: "Pawwash stations are located at Speed Queen laundry sites across Glasgow and Scotland. We're focused on making self-serve dog washing accessible wherever you are — with more locations on the way.",
  },
  {
    title: "What makes us different",
    body: "Open 24/7 with no appointment needed. Professional-grade shampoo, conditioner, and blow dry equipment built into every station. Walk in, wash your dog, and go — it's that simple.",
  },
];

export const aboutMeta = {
  title: "About | Pawwash",
  description:
    "Learn about Pawwash — self-serve dog wash stations in Glasgow. Open 24/7, no appointment needed, professional products included.",
  path: "/about",
};
